import React from 'react';
import {BooleanField, Show, SimpleShowLayout, TextField} from 'react-admin';

const FoodTagShow = (props) => {
    return (
        <Show {...props}>
            <SimpleShowLayout>
                <TextField source="name" />
                <BooleanField addLabel source="deleted" />
            </SimpleShowLayout>
        </Show>
    );
};

export default FoodTagShow;